import { useTranslation } from 'react-i18next';

import { UseTypeOfProductModalReturn } from './types';

/**
 * Custom hook for managing TypeOfProductModal logic and translations
 * Centralizes all business logic and translation handling
 *
 * @returns {UseTypeOfProductModalReturn} Object containing translation functions and computed values
 *
 * @example
 * const { t, getDescriptionKey, selectLabel } = useTypeOfProductModal();
 */
export const useTypeOfProductModal = (): UseTypeOfProductModalReturn => {
  const { t } = useTranslation('menuMaker');

  /**
   * Gets the appropriate description key based on product number
   *
   * @param {number} productNumber - Number of products selected
   * @returns {string} Translation key for the description
   */
  const getDescriptionKey = (productNumber: number): string => {
    return productNumber > 1
      ? 'menuMaker:typeOfProduct.modal.description1a'
      : 'menuMaker:typeOfProduct.modal.description1b';
  };

  const selectLabel = t('menuMaker:typeOfProduct.modal.selectLabel');
  const selectPlaceholder = t('menuMaker:typeOfProduct.modal.selectPlaceholder');
  const submitLabel = 'Confirmar';

  return {
    t,
    getDescriptionKey,
    selectLabel,
    selectPlaceholder,
    submitLabel,
  };
};
